// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__25vRp","range":"MonthRangeSwitch_range__v2oZn","disabled":"MonthRangeSwitch_disabled__2R42T"};